import React, { useRef, useState, useEffect } from 'react'
import styles from './ResourceLib.module.css'
import classNames from 'classnames'
import { message, Modal } from 'antd'
import { useDispatch } from 'react-redux'
import { clearAllCookies, getGradeArrayByCodeStr } from '../../../util/handleObject.js'
import Cookies from 'js-cookie'
import TitleBox from './TitleBox/TitleBox.js'
import ConditionalQuery from './ConditionalQuery/ConditionalQuery.js'
import { getResourceListRequest, getXuekeListRequest } from './ResourceLibApi.js'
import ListItem from './ListItem/ListItem.js'
import DetailModal from './DetailModal/DetailModal.js'

const colorList = [
  'magenta',
  'red',
  'volcano',
  'orange',
  'gold',
  'lime',
  'green',
  'cyan',
  'blue',
  'geekblue',
  'purple',
];
export default function ResourceLib(props) {
  const dispatch = useDispatch()
  const [detailStatus, setDetailStatus] = useState(false)
  const [subjectList, setSubjectList] = useState([])
  const [gradeList, setGradeList] = useState([])
  const [subject, setSubject] = useState('')
  const [grade, setGrade] = useState('')
  const [resourceList, setResourceList] = useState([])
  const [currentResource, setCurrentResource] = useState({})

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    getXuekeList()
    return () => {}
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  function getXuekeList() {
    getXuekeListRequest('', (data) => {
      if (data.ret == 1) {
        let tempGradeList = [
          {
            label: '全部',
            value: '',
          },
        ]
        tempGradeList = tempGradeList.concat(
          data.data.nianji_list.map((item) => ({
            label: item.name,
            value: item.code,
            color: colorList[Math.floor(Math.random() * colorList.length)]
          })))
        setGradeList(tempGradeList)
        let tempSubjectList = [
          {
            label: '全部',
            value: '',
          },
        ]
        tempSubjectList = tempSubjectList.concat(
          data.data.xueke_list.map((item) => ({
            label: item.name,
            value: item.code,
            color: colorList[Math.floor(Math.random() * colorList.length)]
          }))
        )
        setSubjectList(tempSubjectList)
        getResourceList(subject, grade,tempGradeList,tempSubjectList,0,10000000)
      } 
      else{
        message.error(data.msg)
      }
    })
  }
  function getResourceList(subject, grade,tempGradeList,tempSubjectList,offset,limit) {
    // 查询资源
    getResourceListRequest(grade, subject,offset,limit, (data) => {
      if (data.ret == 1) {
        setResourceList(data.data.map((item) => ({
          ...item,
          nianjiList: getGradeArrayByCodeStr(tempGradeList,item.shiyong_nianji),
          xuekeList: getGradeArrayByCodeStr(tempSubjectList,item.shiyong_xueke),
        })))
      }
      else{
        message.error(data.msg)
      }
    })
  }
  return (
    <div className={styles.background} style={{ paddingBottom: 30 }}>
      <TitleBox />
      <ConditionalQuery
        subjectList={subjectList}
        gradeList={gradeList}
        subject={subject}
        setSubject={(e) => setSubject(e)}
        grade={grade}
        setGrade={(e) => setGrade(e)}
        onSearch={() => {
          // 查询资源
          getResourceList(subject, grade,gradeList,subjectList,0,10000000)
        }}
      />
      <div className={styles.listContainer}>
        {resourceList.map((item, index) => (
          <ListItem
            key={index}
            info={item}
            openDetailModal={(e) => {
              setDetailStatus(true)
              setCurrentResource(item)
            }}
            setCurrentResource={(resourceItem) => {
              setCurrentResource(resourceItem)
              setResourceList(resourceList.map((item) => {
                if (item.code == resourceItem.code) {
                  return resourceItem
                }
                return item
              }))
            }}
          />
        ))}
      </div>
      <DetailModal
        currentResource={currentResource}
        visible={detailStatus}
        handleCancel={(e) => {
          setDetailStatus(false)
        }}
        setCurrentResource={(resourceItem) => {
          setCurrentResource(resourceItem)
          setResourceList(resourceList.map((item) => {
            if (item.code == resourceItem.code) {
              return resourceItem
            }
            return item
          }))
        }}
      />
    </div>
  )
}
